import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initGetResults } from "../redux/actions/scenariosActions";
import { initCompanions, initGetProfile } from "../redux/actions";
const useRecommendations = () => {
  const { results, isLoading, error } = useSelector(state => state.scenariosReducer);
  const dispatch = useDispatch()
  const hasHitTheApi = useRef(false)
  const isErrorPricing = error?.detail;
  useEffect(() => {
    if (!hasHitTheApi.current) {
      dispatch(initGetResults())
          dispatch(initGetProfile())
      dispatch(initCompanions({ page: 1,per_page:50 }));
      hasHitTheApi.current = true
    }
    return ()=>hasHitTheApi.current = false
  }, [dispatch])

  return {
    results,
    isLoading,
    isErrorPricing,
  };
};

export default useRecommendations;
